import { useEffect, useState } from "react";
import styled from "styled-components";
import DesktopPageHeader from "../../../../components/DesktopPageHeader";
import RankingDesktop from "../components/RankingDesktop";
import { OWNER_RANKING_TYPE, useOwnerRanking } from "../../../../hooks/useOwnerRanking";
import { useOwnerRestaurantSelection } from "../../../../hooks/useOwnerRestaurantSelection";

const rankingTypeOptions = [
  { value: OWNER_RANKING_TYPE.GLOBAL, label: "Ranking global" },
  { value: OWNER_RANKING_TYPE.COMMUNE, label: "Ranking comunal" },
  { value: OWNER_RANKING_TYPE.REGION, label: "Ranking regional" },
];

export const OwnerRankingPage = ({ resto, rankingType = OWNER_RANKING_TYPE.GLOBAL }) => {
  const { getRanking, rankingData, loading, error } = useOwnerRanking();
  const [current, setCurrent] = useState(rankingType);
  const [restoName, setRestoName] = useState("");
  const [avatar, setAvatar] = useState("");
  const [restoAddress, setRestoAddress] = useState("");
  const [restoId, setRestoId] = useState("");
  const { selectedOwnerRestaurantId, selectedOwnerRestaurant } = useOwnerRestaurantSelection();

  useEffect(() => {
    const selected = selectedOwnerRestaurant || resto;
    if (!selected) return;

    const selectedId = String(
      selectedOwnerRestaurantId || selected?._id || selected?.id || selected?.place_id || ""
    );
    setRestoId(selected?._id || selected?.id || selectedId);
    setRestoName(selected?.name || "");
    setRestoAddress(selected?.address || "");
    setAvatar(selected?.brand || "");
  }, [resto, selectedOwnerRestaurant, selectedOwnerRestaurantId]);

  useEffect(() => {
    if (!restoId) return;
    setCurrent(rankingType);
    getRanking(restoId, rankingType);
  }, [getRanking, rankingType, restoId]);

  const handleRanking = async (value) => {
    setCurrent(value);
    if (!restoId) return;
    await getRanking(restoId, value);
  };

  return (
    <>
      <PageContainer>
        <BannerWrap>
          <DesktopPageHeader img={avatar} alt={restoName} />
        </BannerWrap>
        <RankingDesktop
          data={rankingData?.ranking || []}
          total={rankingData?.total || 0}
          position={rankingData?.pos || 0}
          countries={rankingTypeOptions}
          selectedCountry={current}
          onCountryChange={handleRanking}
          loading={loading}
          error={error}
        />
      </PageContainer>
      <BottomSpacer />
    </>
  );
};

export default OwnerRankingPage;

const PageContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const BannerWrap = styled.div`
  @media (max-width: 1024px) {
    display: none;
  }
`;

const BottomSpacer = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    height: 100px;
  }
`;
